export default {
  translation: {
    common: {
      emailOrUsername: '郵箱或使用者名稱',
      invalidEmailOrUsername: '無效的郵箱或使用者名稱',
      invalidPassword: '密碼錯誤',
      logInToPlanka: '登入至 Planka',
      noInternetConnection: '沒有網路連接',
      pageNotFound_title: '找不到頁面',
      password: '密碼',
      projectManagement: '專案管理',
      serverConnectionFailed: '伺服器連接失敗',
      unknownError: '未知錯誤，請稍後重試',
      useSingleSignOn: '使用單一登入',
    },

    action: {
      logIn: '登入',
      logInWithSSO: '使用SSO登入',
    },
  },
};
